﻿<script setup lang="ts">
    import { reactive, inject, onMounted } from 'vue';
    import { createNew } from './TextMessages.access';
    import { bsAlert } from '@shared/components/bsAlerts';
    import { ScopeAccess, vRequireScopeParams } from '@shared/directives/Scope.access';
    import { injectorAccessInjectionKey } from '@cwd/lib/provider-keys';
    import { UserEventService } from '@shared/Root/UserEvent.service';
    import Loading from '@shared/components/Loading.vue';
    import { useRouter } from 'vue-router';
    import { Permissions } from '@shared/Root/Permissions';

    const router = useRouter();

    const injectorAccess = inject(injectorAccessInjectionKey)!;
    const scopeAccess: ScopeAccess = injectorAccess.injector.get(ScopeAccess);
    const userEventService = injectorAccess.injector.get(UserEventService);

    const state = reactive<{
        isBusy: boolean;
        hasScope: boolean;
    }>({
        isBusy: false,
        hasScope: false,
    });

    onMounted(async () => {
        router.replace({ path: '/TextMessages' });

        const requireScopeParams: vRequireScopeParams = {
            Feature: 'Sms',
            Permission: Permissions.Write,
        };

        state.hasScope = scopeAccess.hasScope(requireScopeParams);

        onCreateNew();
    });

    const onCreateNew = () => {
        if (state.isBusy || !state.hasScope) return;
        state.isBusy = true;

        createNew()
            .then((textMessage) => {
                userEventService.registerUserEvent('SMS', 'Created draft sms', '');
                document.location = '/TextMessages/' + textMessage.SmsMessageId;
            })
            .catch(() => {
                bsAlert({ type: 'danger', title: $Resources.ErrorCreatingIssueHeading, content: $Resources.ErrorCreatingIssueBody });
                state.isBusy = false;
            });
    };
</script>

<script lang="ts"></script>

<template>
    <Loading :show="state.isBusy"></Loading>
</template>

<style lang="less"></style>

<style scoped lang="less"></style>
